import { EnvironmentManager } from '../../../../modules/src/lib/core/managers/environment.manager';
import { environment } from '../../environments/environment';
import { EnvironmentInterface } from '../../environments/environment.interface';

export abstract class BaseApiController {
  constructor(protected readonly environmentManager: EnvironmentManager) {
  }

  getApiUrl() {
    return this.environmentManager.get<EnvironmentInterface>(environment, 'apiUrl');
  }
}